// Phase A.4 / 8C.6 — Card dispatcher for inline chat cards.
// Renders the appropriate card component based on card_type.

import { SikaGoalCard } from "./SikaGoalCard.tsx";
import { SikaScenarioInlineCard } from "./SikaScenarioInlineCard.tsx";
import { SikaChainStatusCard } from "./SikaChainStatusCard.tsx";
import { SikaReadinessCard } from "./SikaReadinessCard.tsx";
import { SikaMilestoneCard } from "./SikaMilestoneCard.tsx";
import { SikaSecondOpinionCard } from "./SikaSecondOpinionCard.tsx";
import { SikaArtefactCard } from "./SikaArtefactCard.tsx";
import { SikaPartnerCard } from "./SikaPartnerCard.tsx";

interface Props {
  cardType: string;
  data: unknown;
  /** Chat send function for actionable cards. */
  onAction?: (text: string) => void;
  /** True while SIKA is still responding. */
  sending?: boolean;
}

export function SikaCardRenderer({ cardType, data, onAction, sending }: Props): JSX.Element | null {
  switch (cardType) {
    case "goal":
      return <SikaGoalCard data={data} />;
    case "scenario":
      return <SikaScenarioInlineCard data={data} onAction={onAction} sending={sending} />;
    case "chain_status":
      return <SikaChainStatusCard data={data} />;
    case "readiness":
      return <SikaReadinessCard data={data} />;
    case "milestone":
      return <SikaMilestoneCard data={data} />;
    case "second_opinion":
      return <SikaSecondOpinionCard data={data} />;
    case "artefact":
      return <SikaArtefactCard data={data} />;
    case "partner":
      return <SikaPartnerCard data={data} />;
    default:
      return null;
  }
}
